<h1 mat-dialog-title>{{ data.title | translate }}</h1>

<div mat-dialog-content>

  <ng-container>
    <p *ngFor="let txt of data.text">{{ txt | translate }}</p>
  </ng-container>

  <p>
    <mat-form-field class="full-width">
      <mat-label>{{ data.label | translate }}</mat-label>
      <textarea matInput
                rows="8"
                [(ngModel)]="textAreaText">
      </textarea>
    </mat-form-field>
  </p>
</div>

<div mat-dialog-actions align="center">

  <div class="col-sm-6 no-gutters pl-0">
    <button id="{{idPrefix}}btn.ok" mat-raised-button class="full-width" color="accent" *ngIf="data.confirmBtnOverride" (click)="accept()">{{ data.confirmBtnOverride | translate }}</button>
    <button id="{{idPrefix}}btn.ok" mat-raised-button class="full-width" color="accent" *ngIf="!data.confirmBtnOverride" (click)="accept()">{{ 'common.btn.yes' | translate }}</button>
  </div>

  <div class="col-sm-6 no-gutters pr-0">
    <button id="{{idPrefix}}btn.close" mat-raised-button class="full-width" *ngIf="data.closeBtnOverride" (click)="close()">{{ data.closeBtnOverride | translate }}</button>
    <button id="{{idPrefix}}btn.close" mat-raised-button class="full-width" *ngIf="!data.closeBtnOverride" (click)="close()">{{ 'common.btn.no' | translate }}</button>
  </div>

</div>
